export const typeToCommonType = {
  string: "Text",
  number: "Number",
  boolean: "True/False",
  dropdown: "Select One"
};
